import { isEmpty, isNil, isUndefined, get, includes } from "lodash";

/**
 * Checks if a grade scale is applicable for grading at a given depth.
 * Used by GradeScaleDatasetDepthLevels setting (temporary solution for 2.0).
 *
 * @param {Object} gradeScaleDepthLevels - The setting object from GradeScaleDatasetDepthLevels
 * @param {string} plannerElementNodeSetId - The planner element node set ID
 * @param {string} gradeScaleId - The grade scale ID
 * @param {number} depth - The node depth
 * @returns {boolean} - Whether grading is allowed
 */
export const isGradeScaleApplicableAtDepth = ({
  gradeScaleDepthLevels,
  plannerElementNodeSetId,
  gradeScaleId,
  depth,
}) => {
  if (isEmpty(gradeScaleDepthLevels) || isNil(depth)) return true;

  const key = `${plannerElementNodeSetId}::${gradeScaleId}`;
  const allowedDepths = get(gradeScaleDepthLevels, key);

  // Key not present → all depths allowed
  if (isUndefined(allowedDepths)) return true;

  return includes(allowedDepths, depth);
};
